class StatusNotification {
  constructor () {
    this.dataQueue = [];
  }

  setElement ($el) {
    this.$el = $el;
  }

  display (message, timeout, force) {
    force = typeof force === 'undefined' ? false : force;
    timeout = typeof timeout === 'undefined' ? 3000 : timeout;

    if (force) {
      // empty queue
      this.dataQueue = [];
      this._finishDisplaying();
    }
    this.dataQueue.push({ message: message, timeout: timeout });
    this.displayingTimeout || this._displayNext();
  }

  _displayNext () {
    const data = this.dataQueue.shift();

    this.$el && this.$el.addClass('new-content')
      .find('.message').text(data.message);

    this.$el && this.$el.addClass('new-content')
      .find('i').toggleClass('hidden', !!data.timeout);

    if (data.timeout) {
      this.displayingTimeout = setTimeout(() => this._finishDisplaying(), data.timeout);
    }
  }

  _finishDisplaying () {
    this.$el && this.$el.removeClass('new-content');

    if (this.displayingTimeout) {
      clearTimeout(this.displayingTimeout);
      this.displayingTimeout = null;
    }

    this.dataQueue.length && this._displayNext();
  }

  _emptyQueue () {
    this.dataQueue = [];
  }
}

module.exports = new StatusNotification();
